export default {
    configuration: {
        coverDistanceLayerName: 'Estimation - {distance} mètres'
    }

}
